<template>
	<div class="shop-order-page">
		<!-- 页面头部（导航栏 + 面包屑） -->
		<div style="position: relative;z-index: 12;">
			<newsPageHeader :gtype="0" />
		</div>
		
		<div class="rightMask" v-if="payid"></div>
		
		<!-- ====== 选项卡：集齐再发 / 到货即发 ====== -->
		<div class="order-tab-bar animate__animated animate__fadeIn">
			<span class="tab-item" @click="shipType=1,cartsettlementGet()" :class="shipType==1?'tab-active':''">集齐再发</span>
			<span class="tab-item" @click="shipType=2,cartsettlementGet()" :class="shipType==2?'tab-active':''">到货即发</span>
			<!-- <div class="tab-underline"></div> -->
		</div>

		<!-- ====== 主体区域：两列布局 ====== -->
		<div class="order-main-layout animate__animated animate__fadeInUp">
						
			<!-- 左侧列 -->
			<div class="order-left-col">
				<!-- 收货人信息 -->
				<div class="card address-card" v-if="shipType==2">
					<div class="card-header">
						<h3 class="card-title">收货人信息</h3>
						<div class="card-header-right">
							<span class="header-link" @click="link('/userPageLab/myAddr')">新增</span>
							<span class="header-divider"></span>
							<span class="header-link" @click="link('/userPageLab/myAddr')">管理</span>
						</div>
					</div>
					<div class="address-list" :class="addrOpen?'address-list-open':''">
						<!-- 暂无 -->
						<div class="zwBox" style="width: 100%;" v-if="!addrList.length">
							<p>暂无地址信息,请前往添加...</p>
						</div>
						<!-- 列表 -->
						<div class="address-item" @click="addrId = index,cartsettlementGet()" :class="addrId==index?'address-item-active':''" v-for="(item,index) in addrList">
							<el-image class="addr-icon" v-if="addrId==index" :src="require('@/static/CodeBuddyAssets/30862_3378/23.svg')"></el-image>
							<el-image class="addr-icon" v-else :src="require('@/static/CodeBuddyAssets/30862_3378/22.svg')"></el-image>
							<span class="addr-name">{{item.consignee}}</span>
							<span class="addr-phone">{{item.mobile}}</span>
							<div class="addr-detail">
								<span class="addr-country1" v-if="item.addressType==2">自提</span>
								<span class="addr-country2" v-if="item.addressType==1">送货上门</span>
								<span class="addr-country">{{item.countryName||'--'}}</span>
								<span class="addr-address">{{item.provinceName}}{{item.cityName}}{{item.address}}</span>
							</div>
						</div>
					</div>
					<div class="address-expand" @click="addrOpen = !addrOpen">
						<span class="expand-text" v-if="addrOpen">收起全部地址</span>
						<span class="expand-text" v-else>展开全部地址</span>
						<el-image class="expand-icon" :src="require('@/static/CodeBuddyAssets/30862_3378/21.svg')"></el-image>
					</div>
				</div>
				
				<!-- 选择物流方案 -->
				<div class="selWl" v-if="shipType==2">
					<div class="wl-header">
						<div class="wl-title-box">选择物流方案</div>
					</div>
					<div class="wl-list" :class="wlOpen ? 'selWl-open' : ''">
						<!-- 暂无 -->
						<div class="zwBox" style="width: 100%;" v-if="!transportLineList.length">
							<el-image :src="require('@/static/zw.svg')"></el-image>
							<p>该地址暂无物流方案</p>
						</div>
						<!-- 列表 -->
						<div
							v-for="(item, idx) in transportLineList"
							:key="idx"
							class="wl-card"
							:class="{ 'wl-card-active': wlId === idx }"
							@click="wlId = idx">
							<el-image class="wl-card-img" :src="item.icon" :preview-src-list="[item.icon]" fit="cover"></el-image>
							<div class="wl-card-body">
								<div class="wl-card-name">{{ item.name }}</div>
								<div class="wl-card-meta">
									<span class="wl-meta-item">{{ item.deliveryTime }}</span>
									<el-image class="wl-meta-sep" :src="require('@/static/CodeBuddyAssets/30934_8753/' + (wlId === idx ? '5.svg' : '2.svg'))"></el-image>
									<span class="wl-meta-item">计费重量：{{ item.chargeWeight }}KG</span>
								</div>
								<div class="wl-card-sub">{{ item.calculatePriceModeName }}</div>
							</div>
							<div class="wl-card-price">
								<div class="wl-price-value">
									<span class="wl-price-symbol">￥</span>
									<span class="wl-price-amount">{{ item.freightPrice }}</span>
								</div>
								<div class="wl-price-label">预估费用</div>
							</div>
							<div class="wl-card-detail" @click="link('/shopWlMsg',{id:item.id})" :class="{ 'wl-detail-white': wlId === idx }">查看详情</div>
						</div>
					</div>
					<!-- <div class="wl-expand" @click="wlOpen = !wlOpen">
						<span class="wl-expand-text" v-if="wlOpen">收起全部物流方案</span>
						<span class="wl-expand-text" v-else>展开全部物流方案</span>
						<el-image class="wl-expand-icon" :class="{ 'wl-expand-rotate': wlOpen }" :src="require('@/static/CodeBuddyAssets/30934_8753/1.svg')"></el-image>
					</div> -->
				</div>

				<!-- 订单信息 -->
				<div class="card order-card">
					<h3 class="card-title">订单信息</h3>
					<div class="warehouse-row">
						<span class="warehouse-label">寄送仓库：</span>
						<div class="warehouse-select">
							<el-select v-model="warehouseIdx" placeholder="请选择" class="form-select">
								<el-option v-for="item in warehouseArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
					
					<div class="product-table" v-for="(item,index) in groups">
						<div class="table-header">
							<div class="table-header-row">
								<el-image class="store-avatar" :src="require('@/static/CodeBuddyAssets/30862_3378/10.svg')"></el-image>
								<div class="store-tag tag-blue" v-if="item.channelType==1">
									<span>自营</span>
								</div>
								<div class="store-tag tag-red" v-if="item.channelType==2">
									<span>1688</span>
								</div>
								<div class="store-tag tag-orange" v-if="item.channelType==3">
									<span>淘宝</span>
								</div>
								<div class="store-tag tag-red" v-if="item.channelType==4">
									<span>京东</span>
								</div>
								<span class="store-name-text">{{item.merchantName}}</span>
							</div>
						</div>
						<div class="table-body" v-for="(itm,idx) in item.items">
							<el-image class="product-img" :src="itm.picUrl" :preview-src-list="[itm.picUrl]" fit="cover"></el-image>
							<div class="product-info">
								<div class="product-name">{{itm.goodsName}}</div>
								<div class="product-spec">{{itm.specifications.join(' ')}}</div>
							</div>
							<div class="product-qty">数量：{{itm.number}}</div>
							<div class="product-price">
								<span class="p-price-symbol">￥</span>
								<span class="p-price-value">{{itm.price}}</span>
							</div>
						</div>
					</div>
					
				</div>
			</div>

			<!-- 右侧列：付款详情 -->
			<div class="order-right-col">
				<div class="card payment-card">
					<h3 class="card-title payment-card-title">付款详情</h3>
					<div class="payment-fee-row">
						<span class="fee-label">国内运费</span>
						<span class="fee-value">￥{{oAll.freightPrice||'0'}}</span>
					</div>
					<div class="payment-fee-row">
						<span class="fee-label">代购服务费</span>
						<span class="fee-value">￥{{oAll.daigouPrice||'0'}}</span>
					</div>
					<div class="payment-fee-row">
						<span class="fee-label coupon-label">优惠券</span>
						<div class="coupon-value-wrap" @click="openCouponModal">
							<span class="fee-value coupon-prefix">优惠</span>
							<span class="fee-value coupon-discount" v-if="selYh !== ''">-￥{{oAll.couponPrice || 0}}</span>
							<span class="fee-value coupon-discount" v-else>请选择</span>
							<el-image class="coupon-arrow" :src="require('@/static/CodeBuddyAssets/30862_3378/12.svg')"></el-image>
						</div>
					</div>
					<div class="payment-fee-row">
						<span class="fee-label">备注</span>
						<el-input class="fee-remark" v-model="remark" placeholder="选填备注信息"></el-input>
					</div>
					<div class="payment-divider"></div>
					<div class="payment-total-row">
						<span class="total-label">总计：</span>
						<span class="total-price">
							<span class="t-price-symbol">￥</span>
							<span class="t-price-value">{{oAll.actualPrice}}</span>
						</span>
					</div>

					<div class="payment-methods">
						<div class="pay-method" @click="payType = 1">
							<el-image class="pay-icon" :src="require('@/static/CodeBuddyAssets/30862_3378/15.svg')"></el-image>
							<span class="pay-name">微信支付</span>
							<div class="pay-radio-wrap" v-if="payType==1">
								<el-image class="pay-check" :src="require('@/static/CodeBuddyAssets/30862_3378/13.svg')"></el-image>
								<el-image class="pay-check-inner" :src="require('@/static/CodeBuddyAssets/30862_3378/14.svg')"></el-image>
							</div v-else>
							<div class="pay-radio-wrap" v-else>
								<el-image class="pay-radio" :src="require('@/static/CodeBuddyAssets/30862_3378/18.svg')"></el-image>
							</div>
						</div>
						<div class="pay-method" @click="payType = 2">
							<el-image class="pay-icon" :src="require('@/static/CodeBuddyAssets/30862_3378/17.svg')"></el-image>
							<span class="pay-name">支付宝支付</span>
							<div class="pay-radio-wrap" v-if="payType==2">
								<el-image class="pay-check" :src="require('@/static/CodeBuddyAssets/30862_3378/13.svg')"></el-image>
								<el-image class="pay-check-inner" :src="require('@/static/CodeBuddyAssets/30862_3378/14.svg')"></el-image>
							</div v-else>
							<div class="pay-radio-wrap" v-else>
								<el-image class="pay-radio" :src="require('@/static/CodeBuddyAssets/30862_3378/18.svg')"></el-image>
							</div>
						</div>
						<div class="pay-method" @click="payType = 3">
							<div class="pay-icon-wrap">
								<el-image class="pay-icon" :src="require('@/static/CodeBuddyAssets/30862_3378/19.svg')"></el-image>
								<el-image class="pay-icon-inner" :src="require('@/static/CodeBuddyAssets/30862_3378/20.svg')"></el-image>
							</div>
							<span class="pay-name">余额支付({{userInfo.money}})</span>
							<div class="pay-radio-wrap" v-if="payType==3">
								<el-image class="pay-check" :src="require('@/static/CodeBuddyAssets/30862_3378/13.svg')"></el-image>
								<el-image class="pay-check-inner" :src="require('@/static/CodeBuddyAssets/30862_3378/14.svg')"></el-image>
							</div v-else>
							<div class="pay-radio-wrap" v-else>
								<el-image class="pay-radio" :src="require('@/static/CodeBuddyAssets/30862_3378/18.svg')"></el-image>
							</div>
						</div>
					</div>

					<div class="submit-btn" v-if="!payid" @click="submitOrder">提交订单</div>
					<div class="submit-btn" v-if="payid" @click="submitPay">支付订单</div>
					
				</div>
			</div>
		</div>

	<!-- ====== 选择优惠券弹窗 ====== -->
	<el-dialog
		:visible.sync="couponModalVisible"
		width="760px"
		custom-class="coupon-select-dialog"
		:show-close="false"
		:close-on-click-modal="false">
		<div slot="title" class="coupon-modal-header">
			<h2 class="coupon-modal-title">选择优惠券</h2>
			<el-image class="coupon-modal-close" :src="couponCloseIcon" @click="cancelCouponSelection"></el-image>
		</div>
		<div class="coupon-modal-body">
			<div class="zwBox" v-if="!availableCoupons.length" style="padding: 40px 0;">
				<el-image :src="require('@/static/zw.svg')"></el-image>
				<p>暂无可用优惠券</p>
			</div>
			<div
				v-for="(item, idx) in availableCoupons"
				:key="'yh-' + idx"
				class="coupon-modal-card"
				:class="{ 'coupon-modal-card-active': tempSelYh === idx }"
				:style="{ backgroundImage: 'url(' + couponBg + ')' }"
				@click="selectCouponInModal(idx)">
				<div class="coupon-left">
					<div class="coupon-price-area" v-if="item.coupon && item.coupon.couponType==1">
						<span class="price-currency price-currency1">¥</span>
						<span class="price-value">{{ item.coupon.discount }}</span>
					</div>
					<div class="coupon-price-area" v-else-if="item.coupon && item.coupon.couponType==2">
						<span class="price-value">{{ item.coupon.discount }}</span>
						<span class="price-currency">折</span>
					</div>
					<div class="coupon-condition">{{ item.coupon && item.coupon.min ? '满' + (item.coupon.min) + '可用' : '无门槛' }}</div>
				</div>
				<el-image class="coupon-divider" :src="couponDivider"></el-image>
				<div class="coupon-info">
					<span class="coupon-name">{{ item.coupon ? item.coupon.name : '优惠券' }}</span>
					<template v-if="item.coupon && item.coupon.timeType==1">
						<span class="coupon-date">有效期：{{ item.coupon.startTime }} ~ {{ item.coupon.endTime }}</span>
					</template>
					<template v-else-if="item.coupon">
						<span class="coupon-date">有效期：领取后 {{ item.coupon.days }} 天</span>
					</template>
				</div>
				<div class="coupon-radio">
					<div class="radio-outer" :class="{ 'radio-outer-active': tempSelYh === idx }">
						<div class="radio-inner" v-if="tempSelYh === idx"></div>
					</div>
				</div>
			</div>
		</div>
		<div slot="footer" class="coupon-modal-footer">
			<button class="btn-cancel" @click="cancelCouponSelection">取消</button>
			<button class="btn-confirm" @click="confirmCouponSelection">确定</button>
		</div>
	</el-dialog>
	
	<!-- 微信支付弹出框 -->
	<el-dialog
		:visible.sync="wxPayHb"
		width="564px"
		custom-class="transfer-dialog"
		:show-close="false"
		:close-on-click-modal="false">
		<div slot="title" class="td-header">
			<h3 class="td-title">微信扫码支付</h3>
			<el-image class="td-close" :src="require('@/static/CodeBuddyAssets/30934_7523/1.svg')" @click="wxPayHb = false"></el-image>
		</div>
		<div class="td-body">
			<el-image class="maImg" :src="wxpayImg"></el-image>
		</div>
		<div slot="footer" class="td-footer">
			<div class="td-btn td-btn-back" @click="wxPayHb = false">返回</div>
			<div class="td-btn td-btn-submit" @click="getorderdetailPd">我已支付</div>
		</div>
	</el-dialog>
	
	</div>
</template>

<script>
import {
	warehouselist,
	cartsettlement,
	memberAddresslist,
	cartsubmit,
	orderpayDetail,
	orderpay
} from "/src/api/api.js"
import newsPageHeader from '@/components/newsPageHeader.vue'
let payPd;
export default {
	name: 'ShopOrder',
	components: {
		newsPageHeader
	},
	data() {
		return {
			id:0,
			// 仓库
			warehouseArr:[],
			warehouseIdx:0,
			// 订单类型
			shipType:1,
			// 地址选择
			addrId:0,
			addrList:[],
			addrOpen:false,
			// 备注
			remark:'',
			// 结算数据
			oAll:'',
			groups:'',
			// 物流方案
			transportLineList:[],
			wlId: 0,
			wlOpen: false,
			// 优惠券
			availableCoupons:[],
			selYh:-1,
			// 优惠券选择弹窗
			couponModalVisible: false,
			tempSelYh: -1,
			couponBg: require('@/static/CodeBuddyAssets/30870_4636/24.svg'),
			couponDivider: require('@/static/CodeBuddyAssets/30870_4636/25.svg'),
			couponCloseIcon: require('@/static/sel/20.svg'),
			// 支付部分
			payid:0,
			payType:1,
			wxPayHb:false,
		}
	},
	mounted() {
		if(this.$route.query.id){
			this.id = this.$route.query.id*1
		}
		this.memberAddresslistGet()
	},
	methods: {
		// 确认支付
		async submitPay(){
			clearInterval(payPd);
			if(this.payType==2){
				payPd = setInterval(()=>{
					this.getorderdetailPd()
				},1000)
				var url = `http://generalappapi.zhilongapp.com/app/order/pay?orderPayId=${this.payid}&payType=${this.payType}&payEnv=3`
				window.open(url, '_blank');
				return
			}
			var data = {
				orderPayId:this.payid,
				payType:this.payType,
				payEnv:3,
			}
			const res = await orderpay(data)
			if(res.code==200){
				if(this.payType==1){
					this.wxPayHb = true
					this.wxpayImg = res.msg
				}
				if(this.payType==3){
					this.Tips(res.msg)
					this.link('/shopSuss',{id:this.payid})
				}
			}else{this.Tips(res.msg,'error')}
		},
		// 订单详情 判断
		async getorderdetailPd(){
			const res = await orderpayDetail({orderPayId:this.payid})
			if(res.code==200){
				if(res.data.payStatus){
					clearInterval(payPd);
					this.Tips(res.msg)
					this.link('/shopSuss',{id:this.payid})
				}else{
					if(this.wxPayHb){
						this.Tips('请扫码支付','error')
					}
				}
			}else{this.Tips(res.msg,'error')}
		},
		// 提交订单
		async submitOrder() {
			var data = {
				warehouseId:this.warehouseIdx,
				shipStrategy:this.shipType,
				remark:this.remark,
				chargeWeight:this.oAll.chargeWeight,
			}
			// 物流方案
			if(this.shipType==2){
				if(this.transportLineList.length){
					data.transportLinesId=this.transportLineList[this.wlId].id
				}else{
					this.Tips('请选择物流方案')
				}
			}
			// id
			if(this.id){
				data.cartIds = [this.id]
			}
			// 优惠券 普通
			if(this.selYh!=-1){
				data.couponMemberId = this.availableCoupons[this.selYh].id
			}
			// 优惠券 运费
			// if(this.selYh1){
			// 	data.freightCouponMemberId = this.selYh1.id
			// }
			// 地址
			if(this.shipType==2){
				if(!this.addrList.length){
					this.Tips('请选择地址')
					return
				}else{
					var address = this.addrList[this.addrId]
					data.memberAddressId = address.id
				}
			}
			const res = await cartsubmit(data)
			if(res.code==200){
				this.Tips(res.msg)
				this.payid = res.data.id
				this.submitPay()
				// this.link('/shopSuss',{id:res.data.id})
			}else{this.Tips(res.msg,'error')}
		},
		// 地址列表
		async memberAddresslistGet(){
			var data = {}
			const res = await memberAddresslist(data)
			if(res.code==200){
				this.addrList = res.rows
				this.warehouselistGet()
			}else{this.Tips(res.msg,'error')}
		},
		// 仓库列表(全部正常的)
		async warehouselistGet(){
			var data = {}
			const res = await warehouselist(data)
			if(res.code==200){
				(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
				})
				this.warehouseArr = res.rows
				this.warehouseIdx = res.rows[0].id
				this.cartsettlementGet()
			}else{this.Tips(res.msg,'error')}
		},
		// 结算
		async cartsettlementGet() {
			var data = {
				warehouseId:this.warehouseIdx,
				shipStrategy:this.shipType,
			}
			// 物流方案
			if(this.shipType==2){
				if(this.transportLineListItm){
					data.transportLinesId=this.transportLineListItm.id
				}
			}
			// id
			if(this.id){
				data.cartIds = [this.id]
			}
			// 优惠券 普通
			if(this.selYh!=-1){
				data.couponMemberId = this.availableCoupons[this.selYh].id
			}
			// 优惠券 运费
			// 'if(this.selYh1){
			// 	data.freightCouponMemberId = this.selYh1.id
			// }'
			// 地址
			if(this.addrList.length){
				var address = this.addrList[this.addrId]
				data.memberAddressId = address.id
			}
			const res = await cartsettlement(data)
			if(res.code==200){
				this.oAll = res.data
				// this.address = res.data.address
				this.groups = res.data.groups
				this.availableCoupons = res.data.availableCoupons
				// this.availableFreightCoupons = res.data.availableFreightCoupons
				this.transportLineList = res.data.transportLineList
				// this.transportLineListItm = this.transportLineList[this.transportLineListIdx]
			}else{this.Tips(res.msg,'error')}
		},
		// 打开优惠券选择弹窗
		openCouponModal() {
			this.couponModalVisible = true
		},
		// 在弹窗中选中一张优惠券
		selectCouponInModal(idx) {
			this.tempSelYh = idx
			this.selYh = this.tempSelYh
		},
		// 确认优惠券选择
		confirmCouponSelection() {
			this.couponModalVisible = false
			this.cartsettlementGet()
		},
		// 取消优惠券选择
		cancelCouponSelection() {
			this.couponModalVisible = false
		},
	},
	beforeDestroy(){
		clearInterval(payPd);
	},
}
</script>

<style lang="scss" scoped>
.shop-order-page {
	width: 100%;
	// min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 160px;
}

.rightMask{
	width: 950px;
	height: 100%;
	position: fixed;
	// background: pink;
	z-index: 10;
	top: 0px;
	left: 300px;
}

/* ===================================================================
   选项卡
   =================================================================== */
.order-tab-bar {
	padding-top: 28px;
	margin-left: 320px;
	display: flex;
	align-items: center;
	position: relative;
	padding-bottom: 24px;
}
.tab-item {
	font-size: 18px;
	cursor: pointer;
	margin-right: 32px;
	color: #7D7D89;
	font-weight: 400;
	padding-bottom: 15px;
	position: relative;
	&::after{
		content: '';
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		transition:0.3s;
		width: 0px;
		height: 3px;
		background: #0096FF;
		border-radius: 1.5px;
	}
}
.tab-active{
	color: #0096FF;
	font-weight: 500;
	&::after{
		content: '';
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		transition:0.3s;
		width: 32px;
		height: 3px;
		background: #0096FF;
		border-radius: 1.5px;
	}
}
// .tab-item:first-child {
// 	color: #0096FF;
// 	font-weight: 500;
// }
// .tab-item:last-child {
// 	color: #7D7D89;
// 	font-weight: 400;
// }
.tab-underline {
	position: absolute;
	bottom: 0;
	left: 20px;
	width: 60px;
	height: 3px;
	background: #0096FF;
	border-radius: 1.5px;
}

/* ===================================================================
   主体布局
   =================================================================== */
.order-main-layout {
	width: 1280px;
	margin: 16px auto 0;
	display: flex;
}

/* 左侧列 */
.order-left-col {
	width: 916px;
	flex-shrink: 0;
}

/* 右侧列 */
.order-right-col {
	width: 340px;
	margin-left: 24px;
	flex-shrink: 0;
}

/* ===================================================================
   通用卡片
   =================================================================== */
.card {
	background: #fff;
	border-radius: 8px;
	padding: 20px 24px;
	box-sizing: border-box;
}
.card-title {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
}

/* ===================================================================
   收货人信息
   =================================================================== */
.address-card {
	padding-bottom: 16px;
	padding: 20px 17px;
}
.card-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 7px;
}
.card-header-right {
	display: flex;
	align-items: center;
}
.header-link {
	font-size: 14px;
	color: #999;
	cursor: pointer;
}
.header-divider {
	width: 1px;
	height: 12px;
	background: #EDEDED;
	margin: 0 8px;
}
.address-list {
	display: flex;
	flex-wrap: wrap;
	margin-top: 20px;
	height: 100px;
	overflow: hidden;
	transition:0.3s;
	// background: pink;
}
.address-list-open{
	height: 220px;
	overflow-y: scroll;
	transition:0.3s;
}
.address-item {
	width: 280px;
	height: 86px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 4px;
	padding: 16px;
	box-sizing: border-box;
	position: relative;
	// margin-right: 14px;
	margin: 0 7px;
	cursor: pointer;
	margin-bottom: 14px;
}
.address-item:last-child {
	// margin-right: 0;
}
.address-item-active {
	border-color: #0096FF;
}
.addr-icon {
	width: 20px;
	height: 20px;
	position: absolute;
	top: 16px;
	left: 16px;
}
.addr-name {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-left: 30px;
}
.addr-phone {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-left: 8px;
}
.addr-detail {
	display: flex;
	align-items: center;
	margin-top: 12px;
	margin-left: 0;
}
.addr-country {
	font-size: 14px;
	color: #0096FF;
	font-weight: 400;
	flex-shrink: 0;
}
.addr-country1 {
	font-size: 12px;
	color: #FC3C3C;
	border: 1px solid #FC3C3C;
	border-radius: 4px;
	background: #FFE9E9;
	font-weight: 400;
	flex-shrink: 0;
	padding: 0 4px;
	margin-right: 4px;
}
.addr-country2 {
	font-size: 12px;
	color: #FF7120;
	border-radius: 4px;
	background: #FFF5E9;
	border: 1px solid #FF7120;
	font-weight: 400;
	flex-shrink: 0;
	padding: 0 4px;
	margin-right: 4px;
}
.addr-address {
	font-size: 14px;
	color: #999;
	font-weight: 400;
	margin-left: 8px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.address-expand {
	display: flex;
	align-items: center;
	margin-top: 2px;
	margin-left: 8px;
	cursor: pointer;
}
.expand-text {
	font-size: 14px;
	color: #999;
}
.expand-icon {
	width: 14px;
	height: 14px;
	margin-left: 4px;
}

/* ===================================================================
   订单信息
   =================================================================== */
.order-card {
	
}
.warehouse-row {
	display: flex;
	align-items: center;
	margin-top: 26px;
	margin-bottom: 20px;
}
.warehouse-label {
	font-size: 14px;
	color: #999;
}
.warehouse-select {
	width: 270px;
	height: 44px;
	background: #F8F8F8;
	display: flex;
	align-items: center;
	padding: 0 16px;
	margin-left: 8px;
	box-sizing: border-box;
	cursor: pointer;
	::v-deep .el-input__inner{
		padding: 0;
		background: transparent;
		border: none;
	}
	::v-deep .el-select{
		width: 100%;
	}
}
.warehouse-value {
	font-size: 14px;
	color: #333;
	font-weight: 400;
	flex: 1;
}
.warehouse-arrow {
	width: 14px;
	height: 14px;
	flex-shrink: 0;
}

/* 产品表格 */
.product-table {
	width: 100%;
	border: 1px solid #EDEDED;
	border-radius: 6px;
	overflow: hidden;
	margin-bottom: 12px;
}
.table-header {
	height: 39px;
	background: #FAFAFA;
	display: flex;
	align-items: center;
	padding: 0 16px;
}
.table-header-row {
	display: flex;
	align-items: center;
}
.store-avatar {
	width: 18px;
	height: 18px;
}
.store-tag {
	display: inline-block;
	font-size: 12px;
	text-align: center;
	font-weight: 400;
	padding: 0 4px;
	// transform: translateY(-1px);
	line-height: normal;
	border-radius: 3px;
	margin-left: 6px;
}
.tag-orange {
	border: 1px solid #FF7120;
	background: #FFF5E9;
	color: #FF7120;
}
.tag-red {
	border: 1px solid #FC3C3C;
	background: #FFE9E9;
	color: #FC3C3C;
}
.tag-blue {
	border: 1px solid #0096FF;
	background: #E9F5FF;
	color: #0096FF;
}
.store-tag .el-image {
	width: 14px;
	height: 14px;
}
.store-tag-text {
	font-size: 10px;
	color: #FC3C3C;
	font-weight: 400;
	margin-left: 2px;
}
.store-name-text {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-left: 8px;
}
.table-body {
	display: flex;
	align-items: center;
	padding: 16px 24px;
}
.product-img {
	width: 68px;
	height: 68px;
	border-radius: 6px;
	flex-shrink: 0;
	cursor: pointer;
}
.product-info {
	flex: 1;
	margin-left: 12px;
}
.product-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
}
.product-spec {
	font-size: 14px;
	color: #7A7A7A;
	font-weight: 400;
	margin-top: 6px;
}
.product-qty {
	font-size: 14px;
	font-weight: 500;
	color: #666;
	flex-shrink: 0;
	text-align: right;
	margin-right: 30px;
}
.product-price {
	color: #FC3C3C;
	flex-shrink: 0;
	text-align: right;
}
.p-price-symbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.p-price-value {
	font-size: 20px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}

/* ===================================================================
   付款详情（右侧边栏）
   =================================================================== */
.payment-card {
	padding: 20px;
}
.payment-card-title {
	font-size: 15px;
	color: #0096FF;
	margin-bottom: 22px;
}
.payment-fee-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 20px;
	margin-bottom: 12px;
}
.fee-label {
	font-size: 14px;
	color: #333;
}
.fee-value {
	font-size: 14px;
	color: #333;
	text-align: right;
}
.coupon-label {
	font-size: 14px;
	color: #333;
}
.coupon-value-wrap {
	display: flex;
	align-items: center;
}
.coupon-prefix {
	color: #333;
	margin-right: 2px;
}
.coupon-discount {
	color: #FC3C3C;
}
.coupon-arrow {
	width: 14px;
	height: 14px;
	margin-left: 6px;
}
.coupon-value-wrap {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.25s;
}
.coupon-value-wrap:hover {
	opacity: 0.8;
}
.coupon-value-wrap:hover .coupon-arrow {
	transform: translateX(2px);
}
.fee-remark {
	font-size: 14px;
	color: #999;
	text-align: right;
	flex: 1;
	::v-deep .el-input__inner{
		border: none;
		text-align: right;
		padding-right: 0;
	}
}
.payment-divider {
	height: 1px;
	background: #F3F3F3;
	margin: 16px 0;
}
.payment-total-row {
	display: flex;
	align-items: baseline;
	justify-content: flex-end;
	margin-bottom: 16px;
}
.total-label {
	font-size: 14px;
	font-weight: 500;
	color: #333;
}
.total-price {
	color: #FC3C3C;
	margin-left: 6px;
}
.t-price-symbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.t-price-value {
	font-size: 20px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}

/* 支付方式 */
.payment-methods {
	background: #FAFAFA;
	border-radius: 4px;
	padding: 20px;
}
.pay-method {
	display: flex;
	align-items: center;
	height: 24px;
	margin-bottom: 20px;
	position: relative;
	cursor: pointer;
}
.pay-method:last-child {
	margin-bottom: 0;
}
.pay-icon {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}
.pay-icon-wrap {
	width: 24px;
	height: 24px;
	position: relative;
	flex-shrink: 0;
}
.pay-icon-inner {
	width: 14px;
	height: 14px;
	position: absolute;
	left: 5px;
	top: 5px;
}
.pay-name {
	font-size: 14px;
	color: #333;
	margin-left: 12px;
}
.pay-radio-wrap {
	width: 20px;
	height: 20px;
	margin-left: auto;
	position: relative;
}
.pay-check {
	width: 20px;
	height: 20px;
	display: block;
}
.pay-check-inner {
	width: 14px;
	height: 14px;
	position: absolute;
	left: 3px;
	top: 3px;
}
.pay-radio {
	width: 20px;
	height: 20px;
	margin-left: auto;
	display: block;
}

/* 提交按钮 */
.submit-btn {
	width: 300px;
	height: 46px;
	background: #0096FF;
	border-radius: 8px;
	color: #fff;
	font-size: 14px;
	font-weight: 500;
	text-align: center;
	line-height: 46px;
	margin-top: 16px;
	cursor: pointer;
	transition: background 0.3s;
}
.submit-btn:hover {
	background: #33ABFF;
}
/* ===================================================================
   选择物流方案
   =================================================================== */
.selWl {
	background: #fff;
	border-radius: 8px;
	padding: 24px 24px 16px;
	margin-top: 16px;
	// height: 196px;
	// overflow: hidden;
	transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	box-sizing: border-box;
	margin-bottom: 0.16rem;
}
.selWl .selWl-open {
	height: 600px;
	overflow-y: scroll;
}

.wl-header {
	margin-bottom: 20px;
}
.wl-title-box {
	width: 128px;
	height: 46px;
	border: 1px solid #0096FF;
	border-radius: 4px;
	text-align: center;
	line-height: 46px;
	font-size: 14px;
	font-weight: 500;
	color: #0096FF;
	box-sizing: border-box;
}

.wl-list {
	display: flex;
	flex-wrap: wrap;
}
.wl-card {
	width: 423px;
	height: 126px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 8px;
	padding: 24px 20px 22px;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	position: relative;
	cursor: pointer;
	margin-right: 22px;
	margin-bottom: 24px;
	transition: background 0.3s, border-color 0.3s;
}
.wl-card:nth-child(even) {
	margin-right: 0;
}
.wl-card.wl-card-active {
	background: #0096FF;
	border-color: #0096FF;
}
.wl-card-img {
	width: 80px;
	height: 80px;
	border-radius: 6px;
	flex-shrink: 0;
	cursor: pointer;
	background: #fff;
}
.wl-card-body {
	margin-left: 12px;
	flex: 1;
}
.wl-card-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	transition: color 0.3s;
}
.wl-card-active .wl-card-name {
	color: #fff;
}
.wl-card-meta {
	display: flex;
	align-items: center;
	margin-top: 10px;
}
.wl-meta-item {
	font-size: 14px;
	color: #7A7A7A;
	transition: color 0.3s;
}
.wl-card-active .wl-meta-item {
	color: #fff;
}
.wl-meta-sep {
	width: 4px;
	height: 14px;
	margin: 0 10px;
	flex-shrink: 0;
}
.wl-card-sub {
	font-size: 14px;
	color: #7A7A7A;
	margin-top: 4px;
	transition: color 0.3s;
}
.wl-card-active .wl-card-sub {
	color: #fff;
}

.wl-card-price {
	text-align: right;
	position: absolute;
	top: 20px;
	right: 20px;
}
.wl-price-value {
	color: #FC3C3C;
	transition: color 0.3s;
}
.wl-card-active .wl-price-value {
	color: #fff;
}
.wl-price-symbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.wl-price-amount {
	font-size: 20px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}
.wl-price-label {
	font-size: 12px;
	color: #FC2933;
	margin-top: 2px;
	transition: color 0.3s;
}
.wl-card-active .wl-price-label {
	color: #fff;
}

.wl-card-detail {
	position: absolute;
	bottom: 22px;
	right: 20px;
	font-size: 14px;
	color: #0096FF;
	cursor: pointer;
	transition: color 0.3s;
}
.wl-card-active .wl-card-detail {
	color: #fff;
}

.wl-expand {
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-top: 8px;
	margin-left: 8px;
}
.wl-expand-text {
	font-size: 14px;
	color: #999;
}
.wl-expand-icon {
	width: 14px;
	height: 14px;
	margin-left: 4px;
	transition: transform 0.3s;
}
.wl-expand-rotate {
	transform: rotate(180deg);
}

/* ===================================================================
   选择优惠券弹窗
   =================================================================== */
::v-deep .coupon-select-dialog {
	border-radius: 8px;
	overflow: hidden;

	.el-dialog__header {
		padding: 0;
		margin: 0;
	}

	.el-dialog__body {
		padding: 0 24px 8px;
	}

	.el-dialog__footer {
		padding: 0 24px 24px;
	}
}

.coupon-modal-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	background: #f7fafc;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
	box-sizing: border-box;
}
.coupon-modal-title {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
}
.coupon-modal-close {
	width: 16px;
	height: 16px;
	cursor: pointer;
	transition: opacity 0.25s;
}
.coupon-modal-close:hover {
	opacity: 0.7;
}
.coupon-modal-body {
	display: flex;
	flex-wrap: wrap;
	padding: 20px 0 4px;
	max-height: 480px;
	overflow-y: auto;
}
.coupon-modal-card {
	width: 343px;
	height: 93px;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	border-radius: 8px;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	overflow: hidden;
	margin-right: 16px;
	margin-bottom: 16px;
	flex-shrink: 0;
	position: relative;
	cursor: pointer;
	border: 2px solid transparent;
	transition: border-color 0.25s, transform 0.15s, box-shadow 0.25s;
}
.coupon-modal-card:nth-child(2n) {
	margin-right: 0;
}
.coupon-modal-card:hover {
	transform: translateY(-2px);
	// box-shadow: 0 6px 16px rgba(0, 150, 255, 0.18);
}
.coupon-modal-card-active {
	// border-color: #0096FF;
	// box-shadow: 0 4px 12px rgba(0, 150, 255, 0.25);
}
.coupon-modal-card .coupon-left {
	width: 109px;
	height: 93px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.coupon-modal-card .coupon-price-area {
	display: flex;
	align-items: baseline;
	justify-content: center;
}
.coupon-modal-card .price-currency {
	font-size: 16px;
	color: #FC3C3C;
	font-weight: 400;
}
.coupon-modal-card .price-currency1 {
	transform: translateX(-4px) translateY(-4px);
}
.coupon-modal-card .price-value {
	font-size: 36px;
	color: #FC3C3C;
	font-weight: 400;
}
.coupon-modal-card .coupon-condition {
	width: 73px;
	height: 24px;
	background: #fff;
	border-radius: 5px;
	text-align: center;
	line-height: 24px;
	font-size: 12px;
	color: #FC3C3C;
	font-weight: 400;
}
.coupon-modal-card .coupon-divider {
	width: 4px;
	height: 71px;
	flex-shrink: 0;
	margin-right: 12px;
}
.coupon-modal-card .coupon-info {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.coupon-modal-card .coupon-name {
	font-size: 16px;
	color: #333;
	font-weight: 400;
	margin-bottom: 4px;
}
.coupon-modal-card .coupon-date {
	font-size: 12px;
	color: #666;
	font-weight: 400;
}
.coupon-modal-card .coupon-radio {
	width: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.coupon-modal-card .radio-outer {
	width: 18px;
	height: 18px;
	border: 1.5px solid #D9D9D9;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	transition: border-color 0.25s;
}
.coupon-modal-card .radio-outer-active {
	border-color: #0096FF;
}
.coupon-modal-card .radio-inner {
	width: 10px;
	height: 10px;
	background: #0096FF;
	border-radius: 50%;
}
.coupon-modal-footer {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
}
.coupon-modal-footer .btn-cancel {
	width: 120px;
	height: 40px;
	background: #fff;
	border: 1px solid #D9D9D9;
	border-radius: 6px;
	color: #666;
	font-size: 14px;
	cursor: pointer;
	transition: all 0.25s;
	outline: none;
}
.coupon-modal-footer .btn-cancel:hover {
	border-color: #0096FF;
	color: #0096FF;
}
.coupon-modal-footer .btn-confirm {
	width: 120px;
	height: 40px;
	background: #0096FF;
	border: 1px solid #0096FF;
	border-radius: 6px;
	color: #fff;
	font-size: 14px;
	cursor: pointer;
	transition: all 0.25s;
	outline: none;
}
.coupon-modal-footer .btn-confirm:hover {
	background: #33ABFF;
	border-color: #33ABFF;
}
/* ===================================================================
   线下转账弹窗 (Figma 30934_7523)
   =================================================================== */
.td-header {
	height: 69px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #f8f8f8;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
}
.td-title {
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
}
.td-close {
	width: 16px;
	height: 16px;
	cursor: pointer;
}

.td-body {
	background: #fff;
	padding: 22px 26px;
	.maImg{
		width: 240px;
		height: 240px;
		margin:auto;
		display: block;
	}
}
.td-info-card {
	// width: 706px;
	height: 120px;
	background: #FAFAFA;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	padding: 20px;
	box-sizing: border-box;
}
.td-info-row {
	margin-bottom: 8px;
	position: relative;
}
.td-info-row:last-child {
	margin-bottom: 0;
}
.td-info-label {
	font-size: 14px;
	color: #999AA3;
}
.td-label-left {
	margin-left: 20px;
}
.td-info-value {
	font-size: 14px;
	color: #2F3541;
}
.td-copy-icon {
	width: 16px;
	height: 16px;
	position: absolute;
	right: 0;
	top: 0;
	cursor: pointer;
}

.td-remark-row {
	display: flex;
	align-items: center;
	margin-top: 20px;
}
.td-remark-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
	flex-shrink: 0;
	margin-right: 16px;
}
.td-remark-input {
	flex: 1;
	.avatar-img {
		width: 0.90rem;
		height: 0.90rem;
		border-radius: 0.06rem;
		flex-shrink: 0;
	}
}
.td-remark-input ::v-deep .el-input__inner {
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 14px;
	color: #333;
	padding-left: 16px;
}
.td-remark-input ::v-deep .el-input__inner::placeholder {
	color: #C6C6C6;
}

.td-footer {
	display: flex;
	justify-content: flex-end;
	padding: 16px 24px 24px;
	background: #fff;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
}
.td-btn {
	width: 120px;
	height: 44px;
	border-radius: 6px;
	text-align: center;
	line-height: 44px;
	font-size: 16px;
	cursor: pointer;
	margin-left: 14px;
	transition: background 0.3s;
}
.td-btn-back {
	background: #E9F6FF;
	color: #0096FF;
}
.td-btn-submit {
	background: #0096FF;
	color: #fff;
}
.td-btn-submit:hover {
	background: #33ABFF;
}

/* ===== 确认支付按钮 ===== */
.confirm-row {
	width: 1596px;
	margin: 24px auto 0;
	display: flex;
	justify-content: flex-end;
}
.confirm-btn {
	width: 184px;
	height: 60px;
	background: #0096FF;
	border-radius: 10px;
	color: #fff;
	font-size: 18px;
	font-weight: 500;
	text-align: center;
	line-height: 60px;
	cursor: pointer;
	transition: background 0.3s;
}
.confirm-btn:hover {
	background: #33ABFF;
}
</style>
